import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Axios from 'axios';
import queryString from 'query-string';
import Radium from 'radium';
import { ListGroup, ListGroupItem, ListGroupItemHeading } from 'reactstrap';

import ArrowIcon from '../icons/RightArrow';

class HomepageList extends Component {
	state = {
		redirect: '',
		currentElection: '',
	};

	setCallback = (object) => {
		this.props.callbackFromParent(object);
	};

	setName = (object) => {
		this.props.callbackName(object);
	};

	setType = (object) => {
		this.props.setType(object);
	};

	setId = (object) => {
		this.props.setId(object);
	};

	setOffline = (offline) => {
		this.props.setOffline(offline);
	};

	setLeave = (object) => {
		this.props.setLeave(object);
	};

	setIsLoaded = (loaded) => {
		this.props.setIsLoaded(loaded);
	};

	parseDate = (date) => {
		const dateArray = date.split(' ');
		const weekday = dateArray[0];
		const month = dateArray[1];
		const day = dateArray[2];
		const year = dateArray[3];
		const timeArray = dateArray[4].split(':');
		var hour = timeArray[0];
		var am_pm = '';
		if (hour <= 11) {
			am_pm = 'am';
		} else {
			am_pm = 'pm';
		}
		if (hour >= 13) {
			hour = hour - 12;
		}
		if (hour === 0) {
			hour = 12;
		}
		const minute = timeArray[1];
		const formattedDate =
			weekday + ' ' + month + ' ' + day + ' ' + year + ' ' + hour + ':' + minute + ' ' + am_pm;
		return formattedDate;
	};

	handleOnClick = async (index) => {
		this.setIsLoaded(false);
		if (!this.props.list[index].completed) {
			var url = '';
			if (this.props.list[index].type === 'nomination') {
				url = 'https://hcapps.holycross.edu/faculty_elections_admin/available_nominations?';
			} else if (this.props.list[index].type === 'election') {
				url = 'https://hcapps.holycross.edu/faculty_elections_admin/available_elections?';
			} else if (this.props.list[index].type === 'result') {
				url = 'https://hcapps.holycross.edu/faculty_elections_admin/voting_results_api?';
			}
			var args = '';
			if (this.props.list[index].type === 'result') {
				args = {
					id: this.props.list[index].id,
					email: this.props.email,
				};
			} else {
				args = {
					election_id: this.props.list[index].id,
					email: this.props.email,
				};
			}
			const query = queryString.stringify(args, { encode: false });
			var path = url + query;
			await Axios({
				method: 'get',
				url: path,
				timeout: 5000,
				headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
			})
				.then((res) => {
					console.log('successfully queried for sub-divisions');
					this.setCallback(res.data);
					if (this.props.list[index].type === 'result') {
						sessionStorage.setItem('FECresults', JSON.stringify(res.data));
					} else {
						sessionStorage.setItem('FECstatusList', JSON.stringify(res.data));
					}
					this.setName(this.props.list[index].name);
					if (this.props.list[index].type === 'result') {
						sessionStorage.setItem('FECresultsTitle', this.props.list[index].name);
					} else {
						sessionStorage.setItem('FECstatusListTitle', this.props.list[index].name);
					}
					this.setType(this.props.list[index].type);
					sessionStorage.setItem('FECtype', this.props.list[index].type);
					this.setId(this.props.list[index].id);
					sessionStorage.setItem('FECid', this.props.list[index].id);
					this.setOffline(false);
					this.setIsLoaded(true);
				})
				.catch((error) => {
					console.error('error querying for sub-divisions: ', error);
					this.setOffline(true);
				});
			if (this.props.list[index].type === 'result') {
				path =
					'https://hcapps.holycross.edu/faculty_elections_admin/legend?election_id=' +
					this.props.list[index].id;
				await Axios({
					method: 'get',
					url: path,
					timeout: 5000,
					headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
				})
					.then((res) => {
						console.log('successfully queried for leave legend');
						this.setLeave(res.data);
						sessionStorage.setItem('FECleave', JSON.stringify(res.data));
						this.setOffline(false);
					})
					.catch((error) => {
						console.error('error querying for leave legend', error);
						this.setOffline(true);
					});
			}
			if (this.props.list[index].type === 'result') {
				this.setState({ redirect: 'results' });
			} else {
				this.setState({ redirect: 'status' });
			}
		}
	};

	generateList = () => {
		if (!(this.props.list === undefined)) {
			if (this.props.list.length > 0) {
				const List = this.props.list.map((election, index) => {
					const formattedDate = new Date(election.end_date).toString();
					return (
						<ListGroupItem
							className="list-group-item-action"
							style={election.completed ? completedStyle : itemStyle}
							key={index}
							onClick={() => this.handleOnClick(index)}
						>
							<div>
								<ListGroupItemHeading>
									{election.name} {this.props.type === 'result' ? election.year : ''}
								</ListGroupItemHeading>
								<small>
									<i>
										{this.props.type === 'result' ? 'Ended: ' : 'Ends on: '}
										{this.parseDate(formattedDate)}
									</i>
								</small>
							</div>
							<div style={iconBlockStyle}>
								{election.completed ? (
									<p>{'Ballot Submitted'}</p>
								) : (
									<ArrowIcon width="32px" height="32px" />
								)}
							</div>
						</ListGroupItem>
					);
				});
				return List;
			}
			return (
				<div>
					<p style={textStyle}>
						There is currently nothing available at this time. If this is a mistake please contact{' '}
						<a href="mailto: cne@holycross.edu">cne@holycross.edu</a>
					</p>
				</div>
			);
		}
		return null;
	};
	message = (type) => {
		if (type === 'nomination') {
			return (
				<p className="mb-0">These are all the nominations available for your participation:</p>
			);
		} else if (type === 'election') {
			return <p className="mb-0">These are all the elections available for your participation:</p>;
		} else if (type === 'result') {
			return <p className="mb-0">Find all the results of previous elections here:</p>;
		}
	};

	render() {
		if (this.state.redirect === 'status') {
			return <Redirect push to="/status" />;
		}
		if (this.state.redirect === 'results') {
			return <Redirect push to="/results" />;
		}
		return (
			<div style={boxStyle}>
				<h2 style={titleStyle}>{this.props.title}</h2>
				<div style={subtitleStyle}>{this.message(this.props.type)}</div>
				<ListGroup>{this.generateList()}</ListGroup>
			</div>
		);
	}
}

const boxStyle = {
	width: 'auto',
	height: 'auto',
	display: 'flex',
	flexDirection: 'column',
	border: '2px solid #000000',
	borderRadius: '8px',
	boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.15)',
	background: '#602d89',
	marginBottom: '4rem',
};

const titleStyle = {
	color: '#fff',
	padding: '10px 5px 0px 8px',
	fontFamily: 'Avenir',
	lineHeight: '1.4',
	'@media (max-width: 420px)': {
		fontSize: '20px',
	},
	'@media (min-width: 421px)': {
		fontSize: '24px',
	},
};

const subtitleStyle = {
	color: '#fff',
	padding: '10px 5px 10px 8px',
	fontFamily: 'Avenir',
	background: '#333333',
};

const textStyle = {
	fontFamily: 'Avenir',
	padding: '10px 5px 10px 8px',
	background: '#ffffff',
};

const itemStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	cursor: 'pointer',
};

const completedStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	background: '#cccccc',
};

const iconBlockStyle = {
	display: 'flex',
	alignItems: 'center',
};

export default Radium(HomepageList);
